export const trackEvent = (
  trackingType: string,
  configUUID: string,
  rowName: string
) => {
  const data = {
    tracking_type: trackingType,
    config_uuid: configUUID,
    row_name: rowName
  }

  return fetch(`https://keysho.herokuapp.com/analytics/track`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
}

export const trackClick: any = (configUUID: string, rowName: string) => {
  return trackEvent('CLICK', configUUID, rowName)
}

export const trackView: any = (configUUID: string, rowName: string) => {
  return trackEvent('VIEW', configUUID, rowName)
}
